import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { handleCall } from 'utils/index.js';
import { useFirebase } from 'components/Firebase/index.js';

const getQueryKey = (uid) => ['currentUser', 'access', uid];

const useCurrentUserAccess = ({ enabled = true, ...options } = {}) => {
  const firebase = useFirebase();
  const uid = useSelector((state) => state.sessionState.authUser?.uid);
  const masqueradeMode = useSelector((state) => state.ui.masqueradeMode);

  const currentUser = firebase.auth.currentUser;
  const isSignedIn = Boolean(currentUser);

  const queryKey = useMemo(() => getQueryKey(uid), [uid]);

  const { data, ...restQueryData } = useQuery({
    queryKey,
    queryFn: async () => {
      const agent = await firebase.getAgent();
      const { error, body } = await handleCall(agent, { url: '/currentUser/access' });

      if (error) {
        throw new Error(error);
      }

      return body;
    },
    enabled: isSignedIn && !masqueradeMode && enabled,
    ...options,
  });

  const memData = useMemo(() => data || {}, [data]);

  return { data: memData, ...restQueryData };
};

export default useCurrentUserAccess;
